import { Typography } from "antd";
import "./Loading.css";

const Loading = ({ message = "Loading" }) => {
  return (
    <div className="carisity-loading">
      {message && (
        <Typography.Paragraph type="secondary">{message}</Typography.Paragraph>
      )}
      <div className="carisity-loader">
        <div className="circle purple"></div>
        <div className="circle pink"></div>
        <div className="circle blue"></div>
      </div>
    </div>
  );
};

export default Loading;
